export const SET_IS_SEARCHING_TRUE = '[ORDERS] SET_IS_SEARCHING_TRUE';

export const SET_IS_SEARCHING_FALSE = '[ORDERS] SET_IS_SEARCHING_FALSE';
